// The new-chat greeting — the one way every Netwatch chat surface opens an
// empty thread. Used by the dashboard SPA's ChatPage and by the widget's chat
// landing; presentational only, so each host fetches `/salutation` with its own
// auth and passes the finished line down.
//
// Before the first turn the greeting IS the page, not a message in it. It is
// never replayed into the transcript afterwards — once there is a real
// conversation to read, a canned intro at the top is just noise.
//
// Hosts load the matching styles (`@netwatchai/chat-core/salutation.css`; the
// widget inlines them into its shadow DOM).

import type { ReactNode } from 'react'

export interface SalutationProps {
  /** The finished line, name included — e.g. "Happy Friday, Kimita". Rendered
   *  as-is: the server composes phrase-plus-name so the two always agree. */
  text: string
  /** Brand mark rendered beside the line. Optional — surfaces that already
   *  wear the logo in a header (the widget) can leave it out. */
  logo?: ReactNode
  /** Secondary line under the greeting, e.g. a prompt to start typing. */
  sub?: ReactNode
}

export function Salutation({ text, logo, sub }: SalutationProps) {
  return (
    <div className="nw-hello">
      <h2 className="nw-hello-line">
        {logo}
        {text}
      </h2>
      {sub && <div className="nw-hello-sub">{sub}</div>}
    </div>
  )
}
